import { CustomDateFilterValue } from '../components/DateFilter/DateFilter';

const key = 'preset-filters';

export const setPresetFiltersLocalStorage = (
  tableSizeFilterValue?: number,
  limitFilterValue?: number,
  dateFilterValue?: number,
  customDateFilterValue?: CustomDateFilterValue,
) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      tableSizeFilterValue,
      limitFilterValue,
      dateFilterValue,
      customDateFilterValue,
    }),
  );
};

export const getPresetFiltersLocalStorage = (): {
  tableSizeFilterValue?: number;
  limitFilterValue: number;
  dateFilterValue?: number;
  customDateFilterValue?: CustomDateFilterValue;
} => {
  const data = localStorage.getItem(key);

  if (data === null) {
    return {
      limitFilterValue: 0,
    };
  } else {
    const filters = JSON.parse(data);
    if (!filters.limitFilterValue) {
      filters.limitFilterValue = 0;
    }
    return filters;
  }
};
